module.exports = __webpack_public_path__ + "static/img/contact.370898e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/contact.jpg
// module id = TexX
// module chunks = 1